import React from "react";
import { Helmet } from 'react-helmet';
import '../../src/assets/css/app.min.css';
import '../../src/assets/css/dark.css'
import '../../src/assets/css/responsive.css';
import '../../src/assets/css/app.min.css';
import '../../src/assets/css/style.css';
import '../../src/assets/css/fontawesome.min.css';
import OwlCarousel from 'react-owl-carousel';
import 'react-awesome-slider/dist/styles.css';
import Footer from "../Footer";
import ScrollAnimation from 'react-animate-on-scroll';
import axios from 'axios';
import Header from "../Header";
import ConsultationForm from "../components/ConsultationForm";
import "./GameDevelopment.css";

class WebDevelopment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Gamedata: [],
            Description: '',
            Job: [],
        }
        this.onClickShowdetails = this.onClickShowdetails.bind(this);
    }
    componentDidMount() {

        axios.get("/careers")
            .then(response => {                
                const jobs = Array.isArray(response.data) ? response.data : [];
                this.setState({
                    Job: jobs,
                    Description: jobs[0]?.description || ''
                });
            })
            .catch(function (error) {
                console.log(error);
            })       

        axios.get('/games?filter[limit]=55&filter[where][is_deleted]=false&filter[where][is_active]=true&filter[order]=createdat%20DESC').then((response) => {
            const games = Array.isArray(response.data) ? response.data : [];
            console.log("oengines Game Data Data is more games::::::::", games);
            this.setState({
                Gamedata: games,
                Description: games[0]?.description || this.state.Description
            });
        })

    }
    onClickShowdetails(job) {
        console.log("job is:::::::", job);
        localStorage.setItem("Job", JSON.stringify(job));
        window.location.href = '/careerdetail';
    }
    render() {
        var Our_Games;

        {
            this.state.Gamedata.length && (
                Our_Games =
                <section className="team-sec space new-space-bg game-store-section" id="Our_Games">
                    <div className="container z-index-common">
                        <div className="title-area text-center game-store-heading">
                            <span className="sub-title">OUR LIVE GAMES</span>
                            <h2 className="sec-title">Explore Our Published Games</h2>
                            <p>Browse selected games developed by Oengines and view their available store listings.</p>
                        </div>
                        <OwlCarousel
                            className="owl-theme game-store-carousel"
                            loop
                            margin={22}
                            nav
                            dots
                            responsive={{
                                0: { items: 1 },
                                576: { items: 2 },
                                992: { items: 3 },
                                1200: { items: 4 }
                            }}
                        >
                            {this.state.Gamedata.map((gamedata, index) => {
                                const getValidImagePath = (...images) => {
                                    const validImage = images.find(({ file }) => {
                                        if (typeof file !== 'string') {
                                            return false;
                                        }

                                        const imageName = file.trim().toLowerCase();
                                        return imageName && imageName !== 'null' && imageName !== 'undefined';
                                    });

                                    return validImage ? `${validImage.folder}/${validImage.file.trim()}` : '';
                                };
                                const storeBackgroundImage = getValidImagePath(
                                    { folder: 'feature_graphics', file: gamedata.feature_graphics },
                                    { folder: 'feature_graphics', file: gamedata.feature_graphic },
                                    { folder: 'banners', file: gamedata.banner }
                                );
                                const storeBackgroundUrl = storeBackgroundImage ? `http://moregames.oengines.com/images/${storeBackgroundImage}` : '';

                                return (
                                    <div className="game-store-slide" key={gamedata.id || gamedata.game_name || index}>
                                        <article className="game-store-card">
                                            <div
                                                className={`game-store-icon${storeBackgroundUrl ? ' has-store-bg' : ''}`}
                                                style={storeBackgroundUrl ? { backgroundImage: `linear-gradient(180deg, rgba(7, 19, 38, 0.12), rgba(7, 19, 38, 0.72)), url(${storeBackgroundUrl})` } : undefined}
                                            >
                                                <img src={`http://moregames.oengines.com/images/icons/${gamedata.icon}`} alt={`${gamedata.game_name} game icon`} />
                                            </div>
                                            <div className="game-store-content">
                                                <h3 className="game-store-title">{gamedata.game_name}</h3>
                                                <p className="game-store-description">{gamedata.short_description || "Available on selected app stores."}</p>
                                                <div className="game-store-links">
                                                    {gamedata.android_link === '' ? '' :
                                                        <a className="game-store-link" href={`${gamedata.android_link}`} target="_blank" rel="noreferrer" aria-label={`${gamedata.game_name} on Google Play`}>
                                                            <img src="assets/img/icon/play_store.png" alt="Get it on Google Play" className="playstore" />
                                                        </a>
                                                    }
                                                    {gamedata.ios_link === '' ? '' :
                                                        <a className="game-store-link" href={`${gamedata.ios_link}`} target="_blank" rel="noreferrer" aria-label={`${gamedata.game_name} on App Store`}>
                                                            <img src="assets/img/icon/app_store.png" alt="Download on the App Store" className="appstore" />
                                                        </a>
                                                    }
                                                    {gamedata.android_link === '' && gamedata.ios_link === '' &&
                                                        <span className="game-store-unavailable">Store link coming soon</span>
                                                    }
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                );
                            })}
                        </OwlCarousel>
                    </div>
                    <div className="shape-mockup" data-bottom="0" data-left="0">
                        <div className="particle-2" id="particle-2"></div>
                    </div>
                </section>
            )
        }

        var Informations;
        if (Array.isArray(this.state.Job) && this.state.Job.length) {
            Informations = this.state.Job.map((job, Index) =>
                <>
                    <li>
                        <a href="#" onClick={() => this.onClickShowdetails(job)}>{job.job}</a>
                    </li>
                </>
            )
        } else {
            Informations = <div><h4 style={{ color: "Red", fontSize: "20px" }}>No Record Found !</h4></div>;
        }

        var explore;
        if (this.state.Gamedata.length) {
            explore = <a className="as-btn btn-abs" href="#Our_Games">Explore</a>;
        }
        else {
            explore = '';
        }

        const gameDevelopmentServices = [
            {
                image: "assets/img/GameDevelopment/multiplayer_game.jpg",
                title: "Multiplayer Game Development",
                description: "Build real-time multiplayer games with matchmaking, game rooms, secure logic, leaderboards, analytics, wallet flows, and backend integrations.",
                points: ["Real-time gameplay", "Matchmaking and rooms", "Game backend integration"]
            },
            {
                image: "assets/img/GameDevelopment/2d.jpg",
                title: "2D & Casual Game Development",
                description: "Create polished 2D games with responsive controls, refined gameplay loops, optimized sprites, UI screens, animation, and platform-ready builds.",
                points: ["2D gameplay systems", "Sprite and UI assets", "Android, iOS, and web builds"]
            },
            {
                image: "assets/img/GameDevelopment/3d.jpg",
                title: "3D Game Development",
                description: "Develop immersive 3D games with environments, characters, props, camera systems, physics, animation, optimization, and production-ready assets.",
                points: ["3D environments", "Character and prop assets", "Performance optimization"]
            },
            {
                image: "assets/img/GameDevelopment/onlinr-casino.jpg",
                title: "Card, Board & Casino Games",
                description: "Launch card, board, casino, and real-money game platforms with admin tools, reporting, wallets, payments, analytics, and scalable game logic.",
                points: ["Card and board games", "Wallet and payment flows", "Admin and reporting tools"]
            },
            {
                image: "assets/img/GameDevelopment/ar.jpg",
                title: "AR/VR/MR Game Development",
                description: "Create immersive AR, VR, and mixed reality experiences with spatial UI, interactive environments, device-ready performance, and strong visual polish.",
                points: ["AR/VR interaction design", "Spatial experiences", "Device optimization"]
            },
            {
                image: "assets/img/GameDevelopment/vr.jpg",
                title: "Game Art, QA & Live Support",
                description: "Support your game with 2D/3D art, animation, VFX, technical art, QA testing, publishing, content updates, bug fixing, and live operations.",
                points: ["2D/3D art and animation", "QA and device testing", "Publishing and LiveOps"]
            }
        ];

        const gameGenres = [
            "Arcade", "Action", "Adventure", "Board", "Card", "Casino", "Casual", "Educational",
            "Puzzle", "Racing", "RPG", "Sports", "Strategy", "Word", "Quiz", "Simulation"
        ];

        const gameProcess = [
            { step: "01", title: "Discovery", description: "We define the game concept, audience, genre, platforms, monetization, gameplay loop, and technical requirements." },
            { step: "02", title: "Prototype", description: "We validate mechanics, controls, UI direction, art style, backend needs, and production feasibility." },
            { step: "03", title: "Production", description: "Designers, artists, developers, and backend engineers build gameplay, assets, interfaces, integrations, and platform builds." },
            { step: "04", title: "QA & Optimization", description: "We test functionality, devices, performance, memory, loading, gameplay balance, store rules, and release stability." },
            { step: "05", title: "Launch", description: "We prepare store assets, publishing support, analytics, ads, server configuration, and launch-ready builds." },
            { step: "06", title: "LiveOps", description: "We support updates, bug fixes, content drops, analytics review, monetization improvements, and ongoing maintenance." }
        ];

        const gamePlatforms = [
            "Unity", "Unreal Engine", "Android", "iOS", "WebGL", "PC", "Console", "AR/VR",
            "Node.js Backend", "Firebase", "Cloud Deployment", "Ads & Analytics", "Store Publishing", "LiveOps"
        ];

        const gameWhyChoose = [
            { icon: "fa-solid fa-gamepad", title: "Game-First Product Team", description: "Our team covers gameplay engineering, UI/UX, backend, art, animation, QA, publishing, and live support." },
            { icon: "fa-solid fa-server", title: "Backend & Multiplayer Strength", description: "We build APIs, databases, game servers, matchmaking, wallet systems, admin panels, and analytics pipelines." },
            { icon: "fa-solid fa-layer-group", title: "2D, 3D, Art & Animation", description: "Production support includes characters, environments, props, VFX, UI assets, animation, and optimized game-ready assets." },
            { icon: "fa-solid fa-clipboard-check", title: "QA Before Launch", description: "We test gameplay, performance, devices, monetization, store readiness, edge cases, and live build stability." }
        ];

        const gameFaqs = [
            {
                question: "What game development services does Oengines provide?",
                answer: "Oengines provides Unity, Unreal, 2D, 3D, multiplayer, mobile, web, AR/VR/MR, game backend, game art, animation, QA, publishing, and live operations support."
            },
            {
                question: "Can you build both mobile and web games?",
                answer: "Yes. We build games for Android, iOS, WebGL, PC, and other platform targets depending on the project scope and game engine."
            },
            {
                question: "Do you support multiplayer backend development?",
                answer: "Yes. We build APIs, game servers, matchmaking, rooms, leaderboards, databases, admin panels, analytics, and related backend systems."
            },
            {
                question: "Can Oengines help after game launch?",
                answer: "Yes. We support store publishing, content updates, bug fixes, analytics, monetization, ad integration, optimization, and live operations."
            }
        ];

        const gameServiceStructuredData = {
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Game Development Services",
            "provider": {
                "@type": "Organization",
                "name": "Oengines Games LLP",
                "url": "https://www.oengines.com"
            },
            "serviceType": "Game Development",
            "areaServed": "Worldwide",
            "description": "Game development services for Unity, Unreal, 2D, 3D, multiplayer, mobile, web, AR/VR, backend, QA, publishing, and live operations.",
            "offers": gameDevelopmentServices.map((service) => ({
                "@type": "Offer",
                "itemOffered": {
                    "@type": "Service",
                    "name": service.title,
                    "description": service.description
                }
            }))
        };


        return (
            <>
                <Helmet>
                    <title>Game Development Company | 2D, 3D, Unity, Multiplayer Games | Oengines Games LLP</title>
                    <meta name="description" content="Oengines Games LLP provides game development services for Unity, Unreal, 2D, 3D, multiplayer, mobile, web, AR/VR, game backend, QA, publishing, and live operations." />
                    <meta name="keywords" content="game development company, Unity game development, Unreal Engine development, 2D game development, 3D game development, multiplayer game development, mobile game development, web game development, AR VR game development, game backend development" />
                    <link rel="canonical" href="https://www.oengines.com/gamedevelopment" />
                    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(gameServiceStructuredData) }} />
                    <link href="https://cdn.jsdelivr.net/npm/@coreui/coreui@4.2.0/dist/css/coreui.min.css" rel="stylesheet" integrity="sha384-UkVD+zxJKGsZP3s/JuRzapi4dQrDDuEf/kHphzg8P3v8wuQ6m9RLjTkPGeFcglQU" crossorigin="anonymous" />
                    <link href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.css" />
                    <script src="https://cdn.jsdelivr.net/npm/@coreui/coreui@4.2.0/dist/js/coreui.bundle.min.js" integrity="sha384-n0qOYeB4ohUPebL1M9qb/hfYkTp4lvnZM6U6phkRofqsMzK29IdkBJPegsyfj/r4" crossorigin="anonymous"></script>                    
                    <script src="https://cdn.rawgit.com/progers/pathseg/master/pathseg.js" type="text/javascript"></script>                    
                    <script src="../assets/js/script.js" type="text/Javascript"></script>                   
                </Helmet>

                <Header />
                <div className="banner-area banner-12 bg_image--23 bg_image with-down-shadow">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="banner-xii-wrapper">
                                    <div className="banner-content-wrapper">
                                        <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                            <p className="pre-title">Game Development Company</p>
                                        </ScrollAnimation>
                                        <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                            <h1 className="title game-dev-hero-title">Build 2D, 3D, Multiplayer, Mobile & Web Games</h1>
                                        </ScrollAnimation>
                                        <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                            <p className="post-title game-dev-hero-text">Oengines Games LLP builds production-ready games with gameplay engineering, UI/UX, 2D/3D art, animation, backend, multiplayer systems, QA, publishing, and live product support.</p>
                                        </ScrollAnimation>
                                        <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                            {explore}
                                        </ScrollAnimation>
                                        <div className="wallet-image-wrapper row">
                                            <a href="/Arcarde" className="avatar col-auto" data-tooltip="ARCADE"><img src="assets/img/icon/wallet/ARCADE.png" alt="wallet_image" /></a>
                                            <a href="/Action" className="avatar col-auto" data-tooltip="ACTION"><img src="assets/img/icon/wallet/ACTION.png" alt="wallet_image" /></a>
                                            <a href="/Adventure" className="avatar col-auto" data-tooltip="ADVENTURE"><img src="assets/img/icon/wallet/ADVENTURE.png" alt="wallet_image" /></a>
                                            <a href="/Board" className="avatar col-auto" data-tooltip="BOARD"><img src="assets/img/icon/wallet/BOARD.png" alt="wallet_image" /></a>
                                            <a href="/Card" className="avatar col-auto" data-tooltip="CARD"><img src="assets/img/icon/wallet/CARD.png" alt="wallet_image" /></a>
                                            <a href="/Casino" className="avatar col-auto" data-tooltip="CASINO"><img src="assets/img/icon/wallet/CASINO.png" alt="wallet_image" /></a>
                                            <a href="/Casual" className="avatar col-auto" data-tooltip="CASUAL"><img src="assets/img/icon/wallet/CASUAL.png" alt="wallet_image" /></a>
                                            <a href="/Educational" className="avatar col-auto" data-tooltip="EDUCATIONAL"><img src="assets/img/icon/wallet/EDUCATIONAL.png" alt="wallet_image" /></a>
                                            <a href="/Horror" className="avatar col-auto" data-tooltip="HORROR"><img src="assets/img/icon/wallet/HORROR.png" alt="wallet_image" /></a>
                                            <a href="/Music" className="avatar col-auto" data-tooltip="MUSIC"><img src="assets/img/icon/wallet/MUSIC.png" alt="wallet_image" /></a>
                                            <a href="/Puzzle" className="avatar col-auto" data-tooltip="PUZZLE"><img src="assets/img/icon/wallet/PUZZLE.png" alt="wallet_image" /></a>
                                            <a href="/Quiz" className="avatar col-auto" data-tooltip="QUIZ"><img src="assets/img/icon/wallet/QUIZ.png" alt="wallet_image" /></a>
                                            <a href="/Racing" className="avatar col-auto" data-tooltip="RACING"><img src="assets/img/icon/wallet/RACING.png" alt="wallet_image" /></a>
                                            <a href="/Roguelike" className="avatar col-auto" data-tooltip="ROGUELIKE"><img src="assets/img/icon/wallet/ROGUCLIKC.png" alt="wallet_image" /></a>
                                            <a href="/Rpg" className="avatar col-auto" data-tooltip="RPG"><img src="assets/img/icon/wallet/RPG.png" alt="wallet_image" /></a>                                            
                                            <a href="/Simulator" className="avatar col-auto" data-tooltip="SIMULATOR"><img src="assets/img/icon/wallet/SIMULATOR.png" alt="wallet_image" /></a>
                                            <a href="/Sport" className="avatar col-auto" data-tooltip="SPORT"><img src="assets/img/icon/wallet/SPORT.png" alt="wallet_image" /></a>
                                            <a href="/Strategy" className="avatar col-auto" data-tooltip="STRATEGY"><img src="assets/img/icon/wallet/STRATEGY.png" alt="wallet_image" /></a>
                                            <a href="/Word" className="avatar col-auto" data-tooltip="WORD"><img src="assets/img/icon/wallet/WORD.png" alt="wallet_image" /></a>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="game-dev-services-section pt-100 pb-70">
                    <div className="container">
                        <div className="game-dev-section-heading game-dev-section-heading--split">
                            <div>
                                <span>Game Development Services</span>
                                <h2>End-to-End Game Development for Mobile, Web, PC & Immersive Platforms</h2>
                            </div>
                            <p>Oengines brings gameplay engineering, backend, art, animation, QA, publishing, and live support together for reliable game product delivery.</p>
                        </div>

                        <div className="row g-4">
                            {gameDevelopmentServices.map((service, index) => (
                                <div className="col-lg-4 col-md-6" key={service.title}>
                                    <article className="game-dev-service-card">
                                        <div className="game-dev-service-card__media">
                                            <img src={service.image} alt={service.title} />
                                            <span>{String(index + 1).padStart(2, "0")}</span>
                                        </div>
                                        <div className="game-dev-service-card__body">
                                            <h3>{service.title}</h3>
                                            <p>{service.description}</p>
                                            <ul>
                                                {service.points.map((point) => (
                                                    <li key={point}>{point}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </article>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
                <section className="game-dev-genre-section space">
                    <div className="container">
                        <div className="game-dev-section-heading text-center">
                            <span>Game Genres We Build</span>
                            <h2>From Casual Mobile Games to Multiplayer Product Platforms</h2>
                            <p>We support a wide range of game genres with the right mix of gameplay logic, UI, art, backend, analytics, monetization, and live support.</p>
                        </div>
                        <div className="game-dev-genre-list">
                            {gameGenres.map((genre) => (
                                <span key={genre}>{genre}</span>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="game-dev-process-section space">
                    <div className="container">
                        <div className="game-dev-section-heading game-dev-section-heading--split">
                            <div>
                                <span>How We Build Games</span>
                                <h2>A Practical Game Development Process from Idea to LiveOps</h2>
                            </div>
                            <p>Our workflow keeps gameplay, creative production, backend, testing, publishing, and post-launch improvements aligned.</p>
                        </div>
                        <div className="game-dev-process-grid">
                            {gameProcess.map((item) => (
                                <article className="game-dev-process-card" key={item.step}>
                                    <span>{item.step}</span>
                                    <h3>{item.title}</h3>
                                    <p>{item.description}</p>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="game-dev-platform-section space">
                    <div className="container">
                        <div className="game-dev-platform-panel">
                            <div className="row align-items-center g-4">
                                <div className="col-lg-5">
                                    <div className="game-dev-section-heading mb-0">
                                        <span>Platforms & Technologies</span>
                                        <h2>Complete Technical Coverage for Game Product Delivery</h2>
                                        <p>We support game engines, platform builds, backend systems, monetization, analytics, publishing, QA, and live operations.</p>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="game-dev-platform-list">
                                        {gamePlatforms.map((platform) => (
                                            <span key={platform}>{platform}</span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="game-dev-why-section space">
                    <div className="container">
                        <div className="game-dev-section-heading text-center">
                            <span>Why Choose Oengines</span>
                            <h2>Specialized Game, Backend, Art, QA & Support Teams in One Place</h2>
                            <p>Oengines helps clients move faster by combining product thinking, game development, creative production, and engineering support.</p>
                        </div>
                        <div className="row g-4">
                            {gameWhyChoose.map((item) => (
                                <div className="col-lg-3 col-md-6" key={item.title}>
                                    <article className="game-dev-why-card">
                                        <span><i className={item.icon}></i></span>
                                        <h3>{item.title}</h3>
                                        <p>{item.description}</p>
                                    </article>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="game-dev-faq-section space">
                    <div className="container">
                        <div className="game-dev-section-heading text-center">
                            <span>Game Development FAQ</span>
                            <h2>Common Questions Before Starting a Game Project</h2>
                        </div>
                        <div className="game-dev-faq-grid">
                            {gameFaqs.map((item) => (
                                <article className="game-dev-faq-card" key={item.question}>
                                    <h3>{item.question}</h3>
                                    <p>{item.answer}</p>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>
                <div id="Our_Games"></div>
                {Our_Games}               
                <div className="space-top space-bottom why-choose-area" id="contact-sec">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-6 pe-xxl-5 mb-40 mb-xl-0">
                                <div className="title-area mb-35 text-xl-start text-center text-white">
                                    <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                        <span className="sub-title"><img
                                            src="assets/img/theme-img/title_shape_1.svg" alt="shape" />Get in Touch  </span>
                                    </ScrollAnimation>
                                    <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                        <h2 className="sec-title">Have a Game Idea?</h2>
                                    </ScrollAnimation>
                                    <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                        <h2 className="sec-title pt-10">Build Your Game with Oengines.</h2>
                                    </ScrollAnimation>
                                </div>
                                <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                    <p className="mt-n2 mb-30 text-xl-start text-center text-white">Share your game concept, platform goals, target users, and technical needs. Our team will help you shape the next production step.</p>
                                </ScrollAnimation>
                                <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                    <p className="mt-n2 mb-30 text-xl-start text-center text-white">Build immersive, scalable, and launch-ready game experiences for mobile, web, PC, multiplayer, and AR/VR platforms.</p>
                                </ScrollAnimation>
                                <div className="contact-feature-wrap">
                                    <div className="contact-feature" style={{ backgroundColor: "#1F1F22" }}>
                                        <div className="icon-btn" style={{ backgroundColor: "transparent" }}><i className="fa-solid fa-phone"></i></div>
                                        <div className="media-body">
                                            <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                                <p className="contact-feature_label text-white">Call Us On:</p><a href="tel:+19088000393"
                                                    className="contact-feature_link text-white">(0261) - 4054978</a>
                                            </ScrollAnimation>
                                        </div>
                                    </div>
                                    <div className="contact-feature" style={{ backgroundColor: "#1F1F22" }}>
                                        <div className="icon-btn" style={{ backgroundColor: "transparent" }}><i className="fa-solid fa-envelope"></i></div>
                                        <div className="media-body">
                                            <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                                <p className="contact-feature_label text-white">Quick Mail Us:</p><a href="mailto:support@oengines.com"
                                                    className="contact-feature_link text-white">support@oengines.com</a>
                                            </ScrollAnimation>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6 ps-xl-4 game-dev-consultation-col">
                                <h3 className="h4 mt-n2 mb-30 text-center text-white mb-4 game-dev-consultation-title">Book a Consultation</h3>
                                <ConsultationForm
                                    className="game-dev-consultation-form"
                                    fieldClassName="chg-box"
                                    subjectPrefix="GameDevelopment"
                                    buttonClassName="as-btn"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />

            </>
        )
    }
}

export default WebDevelopment;

